import {Component, EventEmitter, Input, Output} from '@angular/core';
import {isNil} from 'lodash-es';

@Component({
  selector: 'app-technical-datasheet-image-preview',
  templateUrl: './technical-datasheet-image-preview.component.html',
  styleUrls: ['./technical-datasheet-image-preview.component.scss']
})
export class TechnicalDatasheetImagePreviewComponent {
  @Input() public technicalDatasheetId: number;
  @Input() public areImagesUploading: boolean;
  @Input() public shouldDownloadImage = false;
  @Output() public imageDownloaded: EventEmitter<string> = new EventEmitter<string>();

  public isImageDownloading(): boolean {
    return isNil(this.areImagesUploading);
  }

  public onImageDownloaded(image: string): void {
    this.imageDownloaded.emit(image);
  }
}
